import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";

import "rxjs/add/operator/toPromise";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";

import { User } from "./../model/UserModel";
import { Organization } from "../model/OrganizationModel";
import { Contributor } from "../model/ContributorModel";

import { environment } from "../environments/environment";

@Injectable()
export class UserService {
  constructor(private http: HttpClient) {}

  public login(user: any): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .post(environment.apiHost + "/login/autenticar/", JSON.stringify(user), {
        headers: headers,
        observe: "response",
      })
      .switchMap((response) => {
        if (response === null || response === undefined) {
          throw "Usuário ou senha inválidos";
        }
        return of(response);
      });
  }

  public loginKey(key: string): Observable<HttpResponse<User>> {
    return this.http
      .get<User>(environment.apiHost + "/login/autenticar/chave/" + key, {
        observe: "response",
      })
      .switchMap((response) => {
        return of(response);
      });
  }

  public getUser(userId: number): Observable<User> {
    return this.http.get<User>(
      environment.apiHost + "/administracao/usuario/" + userId
    );
  }

  public getCustomerInfo(userId: number): Observable<Organization> {
    return this.http
      .get<Contributor>(
        environment.apiHost +
          "/organograma/administracao/colaborador/usuario/" +
          userId
      )
      .switchMap((response) => {
        if (response != null) {
          return this.http
            .get<Organization>(
              environment.apiHost +
                "/organograma/administracao/organizacao/" +
                response.organizacaoId
            )
            .map((resp) => {
              resp.colaborador = response;
              return resp;
            });
        } else {
          return of();
        }
      });
  }

  public logout(): Observable<any> {
    return of();
  }

  public findUserByEmail(usuario: any): Observable<User[]> {
    return this.http.post<User[]>(
      environment.apiHost +
        "/administracao/usuario/verificarEmail?checkDeleted=" +
        false,
      usuario
    );
  }

  public findUserByName(
    name: string,
    clientId: number
  ): Observable<Array<User>> {
    return this.http.get<Array<User>>(
      environment.apiHost +
        "/administracao/usuario/list/name/" +
        name +
        "/client/" +
        clientId
    );
  }

  public findMyTeams(userId: number): Observable<any[]> {
    return this.http.get<any[]>(
      environment.apiHost + "/administracao/team/list/usuario/" + userId
    );
  }

  public resetPassword(email: string, clientId: number): Observable<any> {
    return this.findUserByEmail({ email: email }).switchMap((response) => {
      return this.http
        .get<any>(
          environment.apiHost +
            "/login/recuperar/senha/" +
            email +
            "/cliente/" +
            clientId
        )
        .switchMap((response) => {
          return of();
        })
        .catch((err: HttpErrorResponse) => {
          if (err.status == 200) {
            const res = new HttpResponse({
              body: null,
              headers: err.headers,
              status: err.status,
              statusText: err.statusText,
              url: err.url,
            });
            return Observable.of(res);
          } else {
            return Observable.throw(err);
          }
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/UserService.ts